import { QueryClient } from "@tanstack/react-query";

// hack to use the same client in both index.jsx and redesign/index.tsx
const queryClient = new QueryClient();
export { queryClient };